import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getContentDispositionFilename } from '../../../utils/getContentDispositionFilename'
import fileDownload from 'js-file-download'
import { getUrlWithVersion } from '../../../api/api'

export const downloadActionResult = createAsyncThunk<
    void,
    { actionId: string },
    ThunkConfig<string>
>('actionsSlice/downloadActionResult', async (arg, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { actionId } = arg

    try {
        const response = await api.get(
            getUrlWithVersion(`/actions/${actionId}/result`),
            {
                responseType: 'blob',
            }
        )

        if (response.status === 200) {
            const filename = getContentDispositionFilename(response)
            fileDownload(response.data, filename)
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to download action result')
    }
})
